import { API } from "aws-amplify";

export default async function getTotalDeposits(data) {
  return await API.get("businessBanking", "total-deposits", {
    queryStringParameters: {...data},
  });
};